import { RingProgress as MantineRingProgress } from '@mantine/core';
import type { RingProgressProps as MantineRingProgressProps } from '@mantine/core';

import type { LockedProps } from '../types';

type RingProgressProps = Omit<MantineRingProgressProps, LockedProps>;

export const RingProgress = (props: RingProgressProps) => {
  return <MantineRingProgress {...props} />;
};
